import type { DatalakeOptions } from "@/api/import/datalakes";
import type { FilterField } from "@/components/ResourceTable";
import { VENDOR_LOGO_BASE as LOGO_BASE } from "@/pages/import/vendors";

type StorageType = DatalakeOptions["storage"];

type StorageMeta = {
  label: string;
  // Shown next to the logo, where the logo already carries the vendor.
  shortLabel: string;
  logoUrl: string;
};

const STORAGE_META: Record<StorageType, StorageMeta> = {
  s3: { label: "Amazon S3", shortLabel: "S3", logoUrl: `${LOGO_BASE}/s3.svg` },
  gcs: { label: "Google Cloud Storage", shortLabel: "GCS", logoUrl: `${LOGO_BASE}/gcs.svg` },
  abs: { label: "Azure Blob Storage", shortLabel: "Azure Blob Storage", logoUrl: `${LOGO_BASE}/abs.svg` },
  s3_compatible: { label: "S3 Compatible", shortLabel: "S3 Compatible", logoUrl: `${LOGO_BASE}/s3.svg` },
};

export const getStorageShortLabel = (storage: string) => STORAGE_META[storage as StorageType]?.shortLabel ?? storage;

export const getStorageLogoUrl = (storage: string) => STORAGE_META[storage as StorageType]?.logoUrl ?? "";

export const STORAGE_FILTER_OPTIONS: FilterField["options"] = Object.entries(STORAGE_META).map(([value, meta]) => ({
  value,
  label: meta.label,
}));
